export default __webpack_public_path__ + "static/media/Group 13469.19e59cd9.svg";